// Add your custom JS here.
jQuery(document).ready(function($){
    $.fn.isInViewport = function() {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };


    $(".member .view").on("click", function(){
        $(".member").removeClass("active");
        $(this).closest(".member").addClass("active")
    });
    $(".close-profile").on("click", function(){
        $(".member").removeClass("active");
    });
    $(".email-encode").each(function(){
        $(this).html(atob($(this).data("contact")));
    })
    $(".fa-magnifying-glass").on("click", function(){
        $(this).closest("form").submit();
    })
    $(".hideShow").on("click", function(){
        let target = $(this).data("show-id");
        let other = $(this).data("close-other");
        if($("#"+target).hasClass('closed') && other != ''){
            //close other opened
            $("."+other+".open").toggleClass('closed');
            $("."+other+".open").toggleClass('open');
        }
        $("#"+target).toggleClass('open');
        $("#"+target).toggleClass('closed');
    })
    $(".copyThis").on("click", function(){
        if(window.isSecureContext) {
            let copyText = $(this).data("copy-text");
            navigator.clipboard
                .writeText(copyText)
                .then(() => {
                    alert("successfully copied");
                })
                .catch(() => {
                    alert("something went wrong");
                });
        }
    })
    function countUp(self, value, step, max){
        $(self).html(value.toFixed(0).toLocaleString('en-US'))
        value += step;
        //$("#debugConsole").append(";"+value+" compared to "+step+";")
        if(value <= max){
            $("#debugConsole").append(value+",")
            //console.log("Setting new timeout")
            setTimeout(function(){
                countUp(self, value, step, max)
            }, 10)
        } else {
            $(self).html(max.toFixed(0).toLocaleString('en-US'))
        }

    }
    let debugStarted = false;
    function queueCountUp(){
        $(".countup").each(function(){
            if(!debugStarted) {
                $("#container4").append("<div id='debugConsole' class='d-none'>Add Test Info Here</div>")
                debugStarted = true;
            }
            let self = this;
            let num = $(self).html().replace(",", "")*1
            let duration = 3;
            let num_steps = num/(duration*100)
            $("#debugConsole").append(";"+num+" Starting Repeater;")
            countUp(self, 1, num_steps, num)
        })
    }
    $(window).on('resize scroll', function() {
        $('.countup').each(function() {
            if(!$(this).hasClass('started')) {
                if ($(this).isInViewport()) {
                    $(this).addClass('started')
                    let self = this;
                    let num = $(self).html().replace(",", "")*1
                    let duration = 3;
                    let num_steps = num/(duration*100)
                    countUp(self, 1, num_steps, num)
                }
            }
        });
    });

    function trigger_match(){
        let heights = {};
        $(".matched_heights").each(function(){
            let group = $(this).data("match-group");
            let cont = $(this);
            heights = check_match_section(cont, 1, heights, group)
            heights = check_match_section(cont, 2, heights, group)
            heights = check_match_section(cont, 3, heights, group)
            heights = check_match_section(cont, 4, heights, group)
        })
        for(let g in heights){
            let sections = heights[g];
            for(let s in sections) {
                let h = sections[s];
                if(h != -999){
                    $(`.${g} .section${s}`).css('height', `${h}px`);
                }
            }
        }
    }
    function check_match_section(cont, section, heights, group){
        if(heights[group] == undefined) heights[group] = {};
        if(heights[group][section] == undefined) heights[group][section] = -999;
        cont.find(".section"+section).each(function(){
            let h = $(this).height();
            if(h > heights[group][section]) heights[group][section] = h;
        })
        return heights;
    }
    trigger_match();
})